export function getDiseaseOptions(value) {
  return fetch(`https://scigraph-ontology.monarchinitiative.org/scigraph/vocabulary/search/${value}?limit=20`)
    .then((response) => response.json())
    .then((json) => {
      var arr = [];
      json.forEach((elem) => {
        if(elem.categories[0] === 'disease') {
          arr.push({
            label: elem.labels[0],
            value: elem.curie,
            json: elem
          });
        }
      });

      return { options: arr };
    });
}

export function getComparedAttributeSets(qString) {
  return fetch(`https://sandbox.genome.one/owlsim/compareAttributeSets${qString}`)
    .then((response) => response.json())
    .then((json) => json)
    .catch(e => console.log(e));
}



// WEBPACK FOOTER //
// ./src/containers/RedOctopus/apis.js